<template>
    <div class="hot-func">
        <span class="title" v-html="$getConfigText(block.inner.title)"></span>
        <div class="inner">
            <img v-for="(img, index) in block.inner.imgList" :key="index" :src="img"/>
        </div>
        <block-btn :btn-form="block.btnForm"></block-btn>
    </div>
</template>

<style lang='scss' scoped>
.hot-func{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0;
}
.title{
    width: 1012px;
    font-size: 34px;
    font-weight: bold;
    text-align: center;
}
.inner{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 1200px;
    margin-top: 60px;
    img{
        display: block;
        box-shadow: 0px 3px 25px rgba(0, 0, 0, 0.16);
        border-radius: 10px;
        width: 384px;
        height: 192px;
    }
}
.inner > img:nth-last-child(1){
    margin-right: 0;
}
</style>

<script>
import BlockBtn from './block-btn.vue'
export default {
    props: {
        block: Object
    },
    computed: {
        bcStyle(){
            return `background:${this.block.backColor};`
        }
    },
    components: {
        BlockBtn
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/blocks/hot-func.vue